import axios from 'axios';
import { logout } from 'src/redux/slices/auth';
import { dispatch } from 'src/redux/store';

// Função a ser chamada em caso de resposta não autorizada (status 401)
const handleUnauthorized = () => {
  dispatch(logout())
};

// const axiosInstance = axios.create({ baseURL: "http://localhost:3003" });
const axiosInstance = axios.create({ baseURL: "https://api.hopviagens.com.br" });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    if (response && response.status === 401) {
      handleUnauthorized();
    }
    return Promise.reject((response && response.data) || 'Something went wrong');
  }
);

export default axiosInstance;
